
    import {
        defineComponent,
        PropType,
    } from 'vue';
    import formatNumber from '@/js/common/Domain/Service/mixins/formatNumber';

    import { DatesAndPricesItem } from '../common/types/IMapForDatesTabsStore';
    import useDatesTabItem from '../common/useDatesTabItem';

    export default defineComponent({
        name: 'DatesTabsItemDesktop',
        props: {
            searchDates: {
                type: Array as PropType<string[]>,
                required: true,
            },
            selectedDate: {
                type: String,
                required: true,
            },
            bestPriceDate: {
                type: String,
                default: null,
                required: false,
            },
            loadingState: {
                type: String,
                required: true,
            },
            tabData: {
                type: Object as PropType<DatesAndPricesItem>,
                required: true,
            },
        },
        setup(props, ctx) {
            const {
                isSelected,
                formattedDate,
                dateAlreadySearched,
                isDisabled,
                searchInProgress,
                selectDate,
            } = useDatesTabItem(props, ctx);

            return {
                isSelected,
                formattedDate,
                dateAlreadySearched,
                isDisabled,
                searchInProgress,
                selectDate,
                formatNumber,
            };
        },
    });
